import { createContext, useContext } from 'react';
import { useRetrieveCurrentUser } from 'services/user';

export interface role {
  id: number;
  name: string;
}
export type SalaryRate = {
  amountCurrency: string;
  changedAt: string;
  hourlyAmount: number;
  id: number;
  name: string;
  note: string;
  topicId: number;
};
export interface IUserContext {
  id: number;
  displayName: string;
  firstName: string;
  avatarUrl: string;
  permissions: string[];
  roles: role[] | null | undefined;
  salaryRates: SalaryRate[];
  hidePayment: boolean;
  timeZone: string;
}

const UserContext = createContext<IUserContext>({
  displayName: '',
  firstName: '',
  avatarUrl: '',
  permissions: [],
  id: 0,
  roles: [],
  salaryRates: [],
  hidePayment: false,
  timeZone: '',
});

export const UserProvider: React.FC<{}> = ({ children }) => {
  const { data } = useRetrieveCurrentUser({
    enabled: !!localStorage.getItem('token'),
  });

  return (
    <UserContext.Provider
      value={{
        displayName: data?.data.displayName ?? '',
        id: data?.data.id ?? 0,
        firstName: data?.data.firstName ?? '',
        avatarUrl: data?.data.avatar ?? '',
        permissions: data?.data.permissions ?? [],
        roles: data?.data.roles,
        salaryRates: data?.data.salaryRates ?? [],
        hidePayment: data?.data.hidePayment === 0 ? false : true,
        timeZone: data?.data.timeZone ?? '',
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useCurrentUser = () => useContext(UserContext);
